import "./blogmobilenav.css";

const BlogMobileNav = ({ items, activeItem, onSelect, className }) => {
  return (
    <div className={`blog-mobile-nav ${className}`}>
      {items.map((item) => (
        <button
          key={item}
          onClick={() => onSelect(item)}
          className={`blog-mobile-nav-item ${
            activeItem === item ? "active" : ""
          }`}
        >
          {item}
        </button>
      ))}
    </div>
  );
};

export default BlogMobileNav;
